'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var VERY_SENSITIVE_KEYS = ['password', 'mobile', 'mobileE164', 'dob', 'dobString', 'address', 'providerNumber', 'passcode', 'lnglat', 'membershipNumber', 'landline', 'fax'];
var SENSITIVE_KEYS = [].concat(VERY_SENSITIVE_KEYS, ['firstName', 'lastName', 'username', 'token', 'otkCode', 'email', 'Authorization']);

exports.VERY_SENSITIVE_KEYS = VERY_SENSITIVE_KEYS;
exports["default"] = SENSITIVE_KEYS;
